export const templatePageWithoutCookies = "8CFCC1B8-A459-4B5C-A2C1-279F080ED1EA"

export const CONST_challengeStateTypes = {
	'STATE_TYPE_SCHEDULED': {'css': 'en_cours'},
	'STATE_TYPE_IN_PROGRESS': {'css': 'en_cours'},
	'STATE_TYPE_TO_DECLARE': {'css': 'declarer'},
	'STATE_TYPE_TO_DISPATCH': {'css': 'repartir'},
	'STATE_TYPE_WAITING': {'css': 'en_attente'},
	'STATE_TYPE_FINISHED': {'css': 'remporte'},
	'STATE_TYPE_FAILED': {'css': 'echoue'},
}

export const CONST_EventTypes = {
	'JOUR': {'css': 'journee'},
	'SOIR': {'css': 'soiree'},
	'WEB': {'css': 'webinaire'},
}

export const TRAININGNBJOURISNEW = 10;